import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'ns-finish-paper-account',
  template: require('./finish-paper-account.component.html')
})

export class FinishPaperAccountComponent {
  constructor(route: ActivatedRoute) {
    this.accountType = {
      stepTitle: 'Download Documentation'
    };
  }
}
